function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 150,
  r: 150,
  fill: "#7986CB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M201 143.318L192.515 148.134L149.372 164.417L99 143.318L149.372 57L201 143.318Z",
  fill: "#FEFEFE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M201 143.318L149.372 172.607L99 143.318L149.372 119.8L201 143.318Z",
  fill: "#C0CBF8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M201 163.914L149.372 242.609L99 163.914L149.372 193.198L201 163.914Z",
  fill: "#FEFEFE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M201 163.914L149.372 242.609V193.198L201 163.914Z",
  fill: "#C0CBF8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M201 143.318L192.515 148.134L149.372 123.464V57L201 143.318Z",
  fill: "#C0CBF8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M201 143.318L149.372 172.607V119.8L201 143.318Z",
  fill: "#9EABE2"
});

var SvgEth = function SvgEth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ETH.94216935.svg";
export { ForwardRef as ReactComponent };